exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-m-select[data-v-10e2a7ea] {\n  width: 100%;\n}\n.email-inpu-cls[data-v-10e2a7ea] {\n  width: 100%;\n}\n.backup-warning[data-v-10e2a7ea] {\n  color: #fd349c;\n  font-size: 0.052083rem;\n  line-height: 0.088542rem;\n}\n.roles-label[data-v-10e2a7ea] {\n  text-align: right;\n}\n.roles-label .required-icon[data-v-10e2a7ea] {\n  color: #F56C6C;\n  margin-right: 0.020833rem;\n}\n.autofill-tip[data-v-10e2a7ea] {\n  color: #e6a23c;\n}\n.mgb10[data-v-10e2a7ea] {\n  margin-bottom: 0.052083rem;\n}", ""]);

// exports
